module.exports = __webpack_public_path__ + "static/media/CLHMSGuildLogo.a7d77081.png";